import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalDefaultLogoForSpace: ExperimentalQueries['experimentalDefaultLogoForSpace'] =
	(_, { spaceKey }, { network }) => {
		if (!spaceKey) {
			throw new Error('spaceKey is missing.');
		}

		return fetchJSON(network, `/wiki/rest/ia/1.0/space/defaultLogoForSpace?spaceKey=${spaceKey}`, {
			method: 'GET',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		}).then((data) => ({
			logoDownloadPath: data?.logoDownloadPath,
			__typename: 'ExperimentalDefaultLogoForSpace',
		}));
	};
